module.exports = __webpack_public_path__ + "img/chip.b6123a1d.png";